import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import dynamic from 'next/dynamic';
import { aa } from '../utils/algolia';

// Context
import { useSearch } from '../utils/context/search-provider';

const CartDrawer = dynamic(() => import('../organs/cart'));
const Vestibule = dynamic(() => import('../organs/vestibule'));

const DefaultLayout = (props) => {
  const navigation = useSelector((state) => state.navigation);
  const promotions = useSelector((state) => state.promotions.content);

  const { setAlgoliaUserToken } = useSearch();

  useEffect(() => {
    const { userID, algoliaGuestUserToken } = props;

    // if user is logged in and
    // was not browsing as a guest,
    // then set the userToken in Context & Algolia
    if (userID && !algoliaGuestUserToken) {
      // userToken needs to be a string
      const algoliaUserToken = userID.toString();

      setAlgoliaUserToken(algoliaUserToken);
      aa('setUserToken', algoliaUserToken);
    } else if (!userID && algoliaGuestUserToken) {
      // if user is only a guest,
      // set guestUserToken in Context & Algolia

      setAlgoliaUserToken(algoliaGuestUserToken);
      aa('setUserToken', algoliaGuestUserToken);
    }

    // if the user starts off
    // browsing as a guest
    // then signs into their account,
    // maintain the guestUserToken in Algolia & Context
  }, [props.userID, props.algoliaGuestUserToken]);

  return (
    <div id="main">
      <Vestibule
        navigation={navigation.desktop || {}}
        navigationVariation={navigation.desktopVariation || {}}
        mobileNavigation={navigation.mobile || []}
        promotionContent={promotions || []}
      />

      <CartDrawer />

      {props.children}
    </div>
  );
};

DefaultLayout.whyDidYouRender = true;

DefaultLayout.defaultProps = {
  userID: null,
  algoliaGuestUserToken: null
};

DefaultLayout.propTypes = {
  children: PropTypes.node.isRequired,
  userID: PropTypes.number,
  algoliaGuestUserToken: PropTypes.string
};

const mapStateToProps = (state) => ({
  userID: state.profile.id,
  algoliaGuestUserToken: state.profile.algoliaGuestUserToken
});

const ConnectedDefaultLayout = connect(mapStateToProps, null)(DefaultLayout);

export default ConnectedDefaultLayout;
